import React from 'react';
import BaseSizeSensitiveComponent from "../components/BaseSizeSensitiveComponent";


class TandC extends BaseSizeSensitiveComponent {
    render() {

        var introSectionStyle = {
            marginTop: 15,
            marginBottom: 15,
            marginLeft: 30,
            marginRight: 30,
            color: "#e0e0e0"
        }

        return (
            <section style={introSectionStyle}>
                <p><b>Terms and Conditions:</b></p>
                <p/>
                <p><strong>SMS (Text) message policies:</strong></p>
                <p>Roy Watson, LLC, d/b/a Dela Systems may from time to time send SMS messages to any users who have opted-in to receiving them. We will do our absolute best to ensure that only people who have opted-in will ever receive SMS messages, and only relevant to interests expressed by each user.
                We are aware that SMS messages can incur costs for the recipient so we make a best effort to keep the frequency of messages to a minimum. Rarely would a user receive more than one message per calendar quarter that is not a part of an ongoing conversation with a user. Some messages we may send will be announcements of new app versions to existing app users, or for beta test programs to users who have expressed interest in participating.</p>
                <p></p>
                <p>Users may reply to any of our messages with the text "STOP" to opt out of receiving any future messages. We make a best effort to honor every user effort to opt-out of receiving future messages.</p>
                <p>Help regarding messages can be obtained by texting "HELP" to 1-802-735-1500 or by emailing to support@roywatson.com</p>
                <p>Carriers are not liable for delayed or undelivered messages.</p>
            </section>
        );
    }
}

export default TandC


// WEBPACK FOOTER //
// src/Privacy/TandC.js